module.exports = __webpack_public_path__ + "static/media/photo-8.fd087191.jpg";